module.exports = __webpack_public_path__ + "img/mimg06.b735f879.jpg";